import { N0, N200, N30, N30A, N40, N500, N700, N90, N900 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

/**
 * Layout of Shift Item
 */
export enum Layout {
	/** @description Profile, Name, Time are visible. (>= 100px) */
	FullView = 'full-view',
	/** @description Profile, Name Initials are visible. (>= 52px) */
	SparseView = 'sparse-view',
	/** @description Profile, Name Initials (vertical) are visible. (>= 36px) */
	CompactView = 'compact-view',
	/** @description Profile, First Initial (vertical) are visible. (>= 16px) */
	MiniView = 'mini-view',
	/** @description None are visible. (< 16px) */
	NoneView = 'none-view',
	/** @description Profile, Name are visible. (>= 100px) */
	FullSlimView = 'full-slim-view',
	/** @description Profile, Name Initials are visible. (>= 52px) */
	SparseSlimView = 'sparse-slim-view',
	/** @description Name Initials are visible. (>= 36px) */
	CompactSlimView = 'compact-slim-view',
	/** @description First Initial are visible. (>= 16px) */
	MiniSlimView = 'mini-slim-view',
	/** @description None are visible. (< 16px) */
	NoneSlimView = 'none-slim-view',
}

export const noOneColor = {
	backgroundColor: token('elevation.surface', N0),
	color: token('color.text.accent.gray.bolder', N900),
};

export const deletedColor = {
	backgroundColor: token('color.background.accent.gray.subtlest', N200),
	color: token('color.text.subtlest', N700),
};

export const iconColor = {
	backgroundColor: token('color.icon.subtle', N90),
	color: token('color.icon.inverse', N0),
};

export const borderColor = {
	noone: token('color.border', N30A),
	default: token('color.chart.gray.boldest', '#44546F'),
};

export const SHIFT_BORDER = 8 * 0.25;
export const SHIFT_RADIUS = 8 * 0.75;

export const OVERRIDE_BORDER = 8 * 0.5;

export const PROFILE_SIZE = 8 * 2;

export const TIME_FONT_SIZE = 14 * 0.7;
export const TIME_LINE_HEIGHT = 14 * 1.4;

export const ICON_MARGIN = 8 * 0.25;

const TIMELINE_CONTENT_PADDING = 8;
const CALENDAR_CONTENT_PADDING = 8 * 0.5;

export const CONTENT_PADDING = {
	small: CALENDAR_CONTENT_PADDING,
	medium: TIMELINE_CONTENT_PADDING,
	large: TIMELINE_CONTENT_PADDING,
};

export const OVERRIDE_IMAGE = {
	BACKGROUND: token('color.background.accent.gray.subtle', N500),
	FOREGROUND: token('color.background.accent.gray.subtlest', N200),
};

export const DELETED_IMAGE = {
	BACKGROUND: token('color.background.disabled', N30),
	FOREGROUND: token('color.border', N40),
};
